
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv/opas",
      function () {
        return require("private-next-pages/tv/opas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv/opas"])
      });
    }
  